/**
 * @file calendar mobile navigation
 * @author tobias.frei@notch-interactive.com
 *
 * @module modules/m07-2-calendar-mobile.js
 *
 */

/* Imports */
import Vue from 'vue/dist/vue.min.js';
// import VueI18n from 'vue-i18n';
import mobileNavigation from '../modules/m01-2-mobile-navigation.js';

// import attachFastClick from 'fastclick';
// import helperDom from '../helpers/helper-dom.js';

const instance = {},

    /**
     * Object with default values.
     * instance values can be overridden by passing an options object when creating a knob instance.
     *
     * @typedef defaults
     */
    defaults = {
        moduleId: 'calendar-navigation',
        navClass: 'mobilenav',
        calendarInstance: {}
    };


/* private letiables */
let settings,
    mainModule,
    mobileNav,

    /* private methods */
    createNav = () => {

        new Vue({
            el: mainModule,
            delimiters: ['[[', ']]'],
            data: {
                items: window.filterConfig,
                keymap: window.filtermap
            },
            mounted() {
                // init mobile nav bahaviour
                mobileNavigation({
                    moduleId: 'calendar-navigation',
                    navClass: 'mobilenav',
                    triggerId: 'calendar-trigger',
                    rtl: true
                });
            },
            methods: {
                checkFilterCloud: function(key) {
                    let filterArr = settings.calendarInstance.filtercloud.filter(function(filter){ return filter.key === key; });
                    if(filterArr.length>0) {
                        return true;
                    } else {
                        return false;
                    }
                },
                checkFilterCloud2: function(keys) {
                    let filterArr = settings.calendarInstance.filtercloud.filter(function(filter){
                        return filter.key === keys[0] && filter.parentkey === keys[1] ;
                    });
                    if(filterArr.length>0) {
                        return true;
                    } else {
                        return false;
                    }
                },
                resetFilter: function(index) {
                    settings.calendarInstance.resetFilter(index);
                }
            }
        });
    };

instance.init = (options) => {
    settings = Object.assign({}, defaults, options);

    // get main elements
    mainModule = document.getElementById(settings.moduleId);

    if (!mainModule) {
        return false;
    }

    mobileNav = mainModule.querySelector('.' + settings.navClass);

    if (!mobileNav) {
        console.error('m07-2 no mobileNav');
        return false;
    }

    if (window.filterConfig === undefined) {
        console.error('m07-2 no filterconfig found');
        return false;
    }

    if (window.filtermap === undefined) {
        console.error('m07-2 no filtermap found');
        return false;
    }

    setTimeout(function(){
        document.getElementById('calendar-navigation').addEventListener('closenav', function () {
            // call filter on close nav
            settings.calendarInstance.callFilter();
        }, false);
    }, 1000);

    // create navigation
    createNav();

    return instance;
};

export default instance;
